import classNames from 'classnames';
import type { BootstrapColor } from 'models/BootstrapVars';
import { FC } from 'react';

type LabelProps<Id extends string = string> = {
  id: Id;
  value: string | undefined;
  e2e: string;
};

export function Label<Id extends string>({ id, value, e2e }: LabelProps<Id>) {
  return <input type="text" className="form-control" id={id} value={value} readOnly data-e2e={e2e} />;
}

export const LongLabel: FC<LabelProps> = ({ id, value, e2e }) => (
  <div className="form-control readonly h-auto" id={id} data-e2e={e2e}>
    {value}
  </div>
);

type LabelWithUnitProps = LabelProps & {
  unit: string;
  e2e: string;
  color?: BootstrapColor;
};

export const LabelWithUnit: FC<LabelWithUnitProps> = ({ id, value, unit, e2e, color }) => (
  <div className="input-group input-group-readonly">
    <input
      type="text"
      className={classNames(
        'form-control',
        color !== undefined ? `text-${color} fw-bolder border-bottom border-${color}` : undefined,
      )}
      id={id}
      value={value}
      readOnly
      data-e2e={e2e}
    />
    <span
      className={classNames(
        'input-group-text',
        color !== undefined ? `bg-${color} bg-opacity-20 text-${color}` : undefined,
      )}
      data-e2e={`${e2e}-unit`}
    >
      {unit}
    </span>
  </div>
);

export const InputWithUnit: FC<LabelWithUnitProps> = ({ id, value, unit, e2e }) => (
  <div className="input-group">
    <span className="input-group-text flex-grow-1" id={id} data-e2e={e2e}>
      {value}
    </span>
    <span className="input-group-text" data-e2e={`${e2e}-unit`}>
      {unit}
    </span>
  </div>
);
